import type { TOC } from '@ember/component/template-only'
import { array } from '@ember/helper'
import { t } from 'ember-intl'
import { not } from 'ember-truth-helpers'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { CourseProgressAverages } from 'teacher-ui-client/components/giraffe/charts/course-progress/averages'
import { CourseProgressHistory } from 'teacher-ui-client/components/giraffe/charts/course-progress/history'
import { CourseProgressTotals } from 'teacher-ui-client/components/giraffe/charts/course-progress/totals'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import type { CourseProgressReSpellingRoute } from 'teacher-ui-client/reporting/ui-scope/re/course-progress/spelling/route'
import RouteTemplate from 'ember-route-template'
import { camelize } from '@ember/string'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<CourseProgressReSpellingRoute>
}

export const ReCourseProgressSpelling: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.courseProgressSpelling.re"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.spellingProgressTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.spellingProgressTotals}}>
    {{#each @model.spellingProgressTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressTotals
          @title={{t "reporting.chartTitles.spellingProgressTotals"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.spellingProgressTotals." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.spellingProgressTotals"}}
          @data={{gradeData}}
          @product={{@model.product}}
          @precinct={{@model.precinct}}
          @grade={{fullGradeName gradeData.grade_position}}
        />
      </div>
    {{/each}}
    {{#each @model.spellingProgressAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressAverages
          @data={{gradeData}}
          @precinct={{Precinct.RE_SPELLING}}
          @title={{t (concat "reporting.chartTitles.spellingProgressAverages." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.spellingProgressAverages"}}
        />
      </div>
    {{/each}}
    {{#if @model.spellingProgressHistory}}
      <CourseProgressHistory
        @tooltip={{t "reporting.tooltips.courseProgressHistory.chartInfo"}}
        @students={{@model.scopedStudents}}
        @courseProgressHistory={{@model.spellingProgressHistory}}
        @product={{@model.product}}
        @precinct={{@model.precinct}}
        @uiScope={{@model.uiScope.scope}}
        @studentRouteName="reporting.ui-scope.re.student-summary"
        @themeKey={{ThemeKeys.lightGreen}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReCourseProgressSpelling)
